import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "table-bordered" }
const _hoisted_2 = {
  key: 0,
  class: "sr-only"
}
const _hoisted_3 = {
  key: 1,
  class: "sr-only"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = ["onClick", "onKeydown"]
const _hoisted_6 = ["headers"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "email-list"
}
const _hoisted_9 = { class: "no-padding email-chip" }
const _hoisted_10 = ["aria-label", "onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["aria-label", "onClick"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 4 }
const _hoisted_15 = { class: "fake-link" }
const _hoisted_16 = { key: 5 }
const _hoisted_17 = { class: "fake-link" }
const _hoisted_18 = { key: 6 }
const _hoisted_19 = { key: 7 }
const _hoisted_20 = {
  key: 8,
  class: "checboxContainer"
}
const _hoisted_21 = ["aria-checked", "onKeydown"]
const _hoisted_22 = { key: 9 }
const _hoisted_23 = ["aria-label", "onClick"]
const _hoisted_24 = ["src"]
const _hoisted_25 = { key: 10 }
const _hoisted_26 = { key: 11 }
const _hoisted_27 = ["src"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "no-padding" }
const _hoisted_30 = { class: "no-padding" }
const _hoisted_31 = { key: 13 }
const _hoisted_32 = {
  key: 0,
  class: "item-info"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = ["colspan"]
const _hoisted_36 = { key: 3 }
const _hoisted_37 = ["colspan"]
const _hoisted_38 = { key: 4 }
const _hoisted_39 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTableHeader = _resolveComponent("DataTableHeader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_StatusTag = _resolveComponent("StatusTag")!
  const _component_StatusFournisseurTag = _resolveComponent("StatusFournisseurTag")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    (_ctx.noDataText)
      ? (_openBlock(), _createElementBlock("caption", _hoisted_2, _toDisplayString(_ctx.noDataText), 1))
      : (_openBlock(), _createElementBlock("caption", _hoisted_3, _toDisplayString(_ctx.$t('facture.suivi.tableau.commune')), 1)),
    _createElementVNode("thead", {
      class: _normalizeClass(_ctx.notSticky ? 'not-sticky' : 'sticky')
    }, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (header) => {
          return (_openBlock(), _createBlock(_component_DataTableHeader, {
            key: header.label,
            header: header,
            class: "column",
            onSort: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitSort($event)))
          }, null, 8, ["header"]))
        }), 128))
      ])
    ], 2),
    (_ctx.tableData.length > 0)
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (items) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: items.id,
              class: _normalizeClass([_ctx.isPointer(items) ? 'cursor-pointer-on-pdf-available' : '', "pointer"]),
              tabindex: "0",
              onClick: ($event: any) => (_ctx.emitSelect(items)),
              onKeydown: [
                _withKeys(($event: any) => (_ctx.emitSelect(items)), ["enter"]),
                _withKeys(_withModifiers(($event: any) => (_ctx.emitSelect(items)), ["prevent"]), ["space"])
              ]
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVisibleItems(Object.entries(items)), (item, i) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: item[0],
                  headers: _ctx.tableHeader[i] ? `th-${_ctx.tableHeader[i].sortData || _ctx.tableHeader[i].label}` : undefined,
                  style: _normalizeStyle(_ctx.getStyle(_ctx.tableHeader[i]))
                }, [
                  (item[0] === 'id')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        "aria-label": `${_ctx.$t('list.view.detail')} ${item[1].label}`,
                        to: { name: item[1].pageName, params: { id: item[1].label, value: item[1].value } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item[1].label), 1)
                        ]),
                        _: 2
                      }, 1032, ["aria-label", "to"]))
                    : (item[0] === 'emails')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (Array.isArray(item[1]) && item[1].length)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item[1], (mail, idx) => {
                                  return (_openBlock(), _createElementBlock("li", { key: idx }, [
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(mail), 1)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (item[0] === 'actif')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                            onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["stop"]), ["space"]))
                          }, [
                            _createVNode(_component_Switch, {
                              active: !!item[1],
                              onToggle: ($event: any) => (_ctx.$emit('toggleActif', items))
                            }, null, 8, ["active", "onToggle"])
                          ], 32))
                        : (item[0] === 'actions')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 3,
                              class: "actions",
                              onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["stop"]), ["space"]))
                            }, [
                              _createElementVNode("button", {
                                "aria-label": _ctx.$t('commons.edit'),
                                class: "btn-icon",
                                type: "button",
                                onClick: _withModifiers(($event: any) => (_ctx.$emit('edit', items)), ["stop"])
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.editIcon,
                                  alt: "",
                                  "aria-hidden": "true",
                                  class: "action-icon"
                                }, null, 8, _hoisted_11)
                              ], 8, _hoisted_10),
                              _createElementVNode("button", {
                                "aria-label": _ctx.$t('commons.delete'),
                                class: "btn-icon",
                                type: "button",
                                onClick: _withModifiers(($event: any) => (_ctx.$emit('delete', items)), ["stop"])
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.deleteIcon,
                                  alt: "",
                                  "aria-hidden": "true",
                                  class: "action-icon"
                                }, null, 8, _hoisted_13)
                              ], 8, _hoisted_12)
                            ], 32))
                          : (item[0] === 'idReclamation')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("p", _hoisted_15, _toDisplayString(item[1]), 1)
                              ]))
                            : (item[0] === 'devisId')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createElementVNode("p", _hoisted_17, _toDisplayString(item[1].label), 1)
                                ]))
                              : (item[0] === 'statut')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createVNode(_component_StatusTag, {
                                      status: item[1]
                                    }, null, 8, ["status"])
                                  ]))
                                : (item[0] === 'statutFournisseur')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _createVNode(_component_StatusFournisseurTag, {
                                        status: item[1]
                                      }, null, 8, ["status"])
                                    ]))
                                  : (item[0] === 'uniqueDocumentId' && item[1] !== '')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        _createElementVNode("span", {
                                          "aria-checked": _ctx.isChecked(item[1]),
                                          class: _normalizeClass(_ctx.getCheckedStyle(item[1])),
                                          role: "checkbox",
                                          tabindex: "0",
                                          onKeydown: [
                                            _withKeys(_withModifiers(($event: any) => (_ctx.emitToggle(item[1])), ["stop"]), ["enter"]),
                                            _withKeys(_withModifiers(($event: any) => (_ctx.emitToggle(item[1])), ["prevent","stop"]), ["space"])
                                          ]
                                        }, null, 42, _hoisted_21)
                                      ]))
                                    : (item[0] === 'pdfExist' && item[1] === true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                          _createElementVNode("button", {
                                            "aria-label": _ctx.$t('aria.telecharger.pdf'),
                                            class: "btn-icon",
                                            type: "button",
                                            onClick: _withModifiers(($event: any) => (_ctx.emitDownload(items, $event)), ["stop"])
                                          }, [
                                            _createElementVNode("img", {
                                              src: _ctx.pdfIcon,
                                              alt: "",
                                              "aria-hidden": "true",
                                              class: "pdf-icon"
                                            }, null, 8, _hoisted_24)
                                          ], 8, _hoisted_23)
                                        ]))
                                      : (item[0] === 'pdfExist' && item[1] === false)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[4] || (_cache[4] = [
                                            _createElementVNode("span", null, null, -1)
                                          ]))]))
                                        : (item[0] === 'facturee')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                              (item[1] === true)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: _ctx.checkBoxIcon,
                                                    alt: "",
                                                    "aria-hidden": "true",
                                                    class: "pdf-icon"
                                                  }, null, 8, _hoisted_27))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_28))
                                            ]))
                                          : (item[0] === 'site')
                                            ? (_openBlock(), _createBlock(_component_Popper, {
                                                key: 12,
                                                content: item[1],
                                                arrow: "",
                                                hover: "",
                                                offsetDistance: "0",
                                                placement: "top"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_29, [
                                                    _createElementVNode("span", _hoisted_30, _toDisplayString(item[1]), 1)
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1032, ["content"]))
                                            : (item[0] === 'libelleEquipement' || item[0] === 'equipment')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                  (item[1] && typeof item[1] === 'object')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createElementVNode("span", null, _toDisplayString(item[1].libelle ?? ''), 1),
                                                        (item[1].phase)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(item[1].phase), 1))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(item[1]), 1))
                                                ]))
                                              : (_openBlock(), _createElementBlock("span", {
                                                  key: 14,
                                                  class: _normalizeClass({ 'white-space-pre': item[0] === 'adresse' || item[0] === 'description' })
                                                }, _toDisplayString(item[1]), 3))
                ], 12, _hoisted_6))
              }), 128))
            ], 42, _hoisted_5))
          }), 128)),
          (_ctx.isLoading && _ctx.count !== _ctx.tableData.length)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                _createElementVNode("td", {
                  colspan: Object.entries(_ctx.tableHeader).length,
                  class: "noDataTd"
                }, _toDisplayString(_ctx.$t('search.isLoading')), 9, _hoisted_35)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_36, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", {
                colspan: Object.entries(_ctx.tableHeader).length,
                class: "noDataTd"
              }, _toDisplayString(_ctx.$t('search.isLoading')), 9, _hoisted_37)
            ])
          ]))
        : (_openBlock(), _createElementBlock("tbody", _hoisted_38, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", {
                colspan: Object.entries(_ctx.tableHeader).length,
                class: "noDataTd"
              }, _toDisplayString(_ctx.noDataText ? _ctx.noDataText : _ctx.$t('search.notFound')), 9, _hoisted_39)
            ])
          ]))
  ]))
}